import script from "./feedbackView.vue?vue&type=script&setup=true&lang=js"
export * from "./feedbackView.vue?vue&type=script&setup=true&lang=js"

import "./feedbackView.vue?vue&type=style&index=0&id=23ea46fa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23ea46fa"]])

export default __exports__